import { FilterBaseDto } from '../common/filters/filterBase.dto';
export class DashboardFilter extends FilterBaseDto {
  companies?: string[] = [];
}
